import { render, staticRenderFns } from "./AgendaComponent.vue?vue&type=template&id=4a6b2e73&scoped=true"
import script from "./AgendaComponent.vue?vue&type=script&lang=js"
export * from "./AgendaComponent.vue?vue&type=script&lang=js"
import style0 from "./AgendaComponent.vue?vue&type=style&index=0&id=4a6b2e73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6b2e73",
  null
  
)

export default component.exports